// В.2.b: Донор (liv_donor, common, 1/0/2).
// Посмертие (deathrattle): при смерти Донора его Герой получает +1 ХП
// через healUnit (источник = карта Донора).
//
// Реализация:
//   - Подписываемся на onUnitDiedExtras в hooks.js (общий механизм).
//   - В обработчике: если умерший — Донор, не «Спящий у врага», и не под
//     Молчанием — лечим Героя владельца на 1 ХП через healUnit.
//   - Если Герой на полном ХП — healUnit вернёт actualAmount=0; событие
//     healed не эмитится; всё штатно.
//   - Молчание (current.silenced на момент смерти) блокирует Посмертие —
//     это общая политика onUnitDied для собственных Посмертий карты.
//     Реализуется ЛОКАЛЬНО, т.к. extras не получают флаг silenced —
//     проверяем здесь.

import { registerImplementedAbility } from './warn-unimplemented.js';
import { registerOnUnitDiedExtraHandler } from '../deus/hooks.js';
import { healUnit } from './heal.js';

export const CARD_ID = 'liv_donor';
const LABEL = 'Донор';

registerImplementedAbility(CARD_ID, 'deathrattle');

registerOnUnitDiedExtraHandler((state, payload) => {
  const card = payload?.card;
  if (!card || card.id !== CARD_ID) return;
  // Спящий агент у врага — отдельный сценарий, его Посмертие не работает.
  // У Лив Лайф нет Спящего, но защитимся симметрично с Глобал/Деус.
  if (card.sleeperState != null) return;
  // Молчание блокирует собственное Посмертие (диздок 6.7).
  if (card.current?.silenced) return;
  if (card.silenceSources && card.silenceSources.size > 0) return;
  const ownerIdx = payload.ownerIdx;
  const owner = state.players?.[ownerIdx];
  if (!owner || !owner.hero) return;
  if (owner.hero.hp <= 0) return;
  state.log?.add(`💔 ${LABEL} [${owner.name}]: Посмертие — +1 ХП Герою`);
  healUnit(state, owner.hero, 1, card);
});
